export default "__VITE_ASSET__33d33892__"